export default __webpack_public_path__ + "634ea21f35cdb5a39ea0e0bd120621c5.png";